import { PalletsSummary } from "components/PalletsSummary";
import React from "react";

export const ReservationSummary = ({
	reservationTotals,
	records,
	selectedPalletsUI,
	orderId,
	isStatic = false,
}) => {
	// Calculate dynamic totals based on UI selections
	const calculateDynamicTotals = () => {
		if (!reservationTotals) {
			return { totalPallets: 0, totalBoxes: 0, totalWeight: 0 };
		}

		// If static mode, just return backend totals without calculation
		if (isStatic) {
			return {
				totalPallets: reservationTotals.total_pallets || 0,
				totalBoxes: reservationTotals.total_boxes || 0,
				totalWeight: reservationTotals.total_weight || 0,
			};
		}

		// Start with backend totals
		let totalPallets = reservationTotals.total_pallets || 0;
		let totalBoxes = reservationTotals.total_boxes || 0;
		let totalWeight = reservationTotals.total_weight || 0;

		// If no records, just return backend totals (e.g., when filtering by RESERVED)
		if (!records || records.length === 0) {
			return { totalPallets, totalBoxes, totalWeight };
		}

		// Calculate delta based on UI selections (whole-pallet reservation)
		records.forEach((pallet) => {
			const isPalletSelected = selectedPalletsUI[pallet.id];
			const isPalletAlreadyReserved = pallet.reserved_order_id === orderId;
			const isPalletReservedForAnotherOrder =
				pallet.reserved_order_id && pallet.reserved_order_id !== orderId;

			if (isPalletReservedForAnotherOrder) {
				// Skip red pallets - they're not selectable
				return;
			}

			// If pallet is selected in UI but not yet reserved in backend
			if (isPalletSelected && !isPalletAlreadyReserved) {
				totalPallets += 1;
				totalBoxes += pallet.quantity || 0;
				totalWeight += pallet.net_weight || 0;
			}
			// If pallet was selected but now unselected in UI (and was reserved)
			else if (!isPalletSelected && isPalletAlreadyReserved) {
				totalPallets -= 1;
				totalBoxes -= pallet.quantity || 0;
				totalWeight -= pallet.net_weight || 0;
			}
		});

		return {
			totalPallets: Math.max(0, totalPallets),
			totalBoxes: Math.max(0, totalBoxes),
			totalWeight: Math.max(0, totalWeight),
		};
	};

	const { totalPallets, totalBoxes, totalWeight } = calculateDynamicTotals();

	return (
		<PalletsSummary
			summaryTotals={{
				total_pallets: totalPallets,
				total_boxes: totalBoxes,
				total_weight: totalWeight,
			}}
		/>
	);
};
